import React, { useState } from 'react';
import styled from 'styled-components';
import { useParams } from 'react-router-dom';
import { ResearchExperienceForm } from './ResearchExperienceForm';
import { type ResearchExperienceFormValues } from './types';
import { PAGE_TEXT } from '../lang';
import {
  addApplicationItem,
  useGetResearchExperienceFormData,
  useUpdateResearchExperience,
} from '../../../graphql';
import {
  Accordion,
  Alert,
  type AlertDetails,
  Loading,
} from '../../../../../components';

export type ResearchExperienceContentProps = {
  researchExperienceId?: string;
  enableEdit: boolean;
  isHKPFSApplicant: boolean;
  handleLoading: (callback: () => Promise<void>) => Promise<void>;
  refetchApplication: () => void;
};

export const ResearchExperience: React.FunctionComponent<
  ResearchExperienceContentProps
> = props => {
  const { applicationId: id } = useParams();
  const {
    researchExperienceId,
    enableEdit,
    isHKPFSApplicant,
    refetchApplication,
    handleLoading,
  } = props;
  const [researchExperience, setResearchExperience] = useState(
    researchExperienceId ?? '',
  );
  const [isCreateMode, setIsCreateMode] = useState(!researchExperience);

  let initialValues: ResearchExperienceFormValues = {
    pastResearchExperience: '',
    proposedResearchTopic: '',
    proposedResearchPlan: '',
    reasons: '',
    longTermCareerPlan: '',
    expectedContribution: '',
    others: '',
  };

  const initialResearchProposals: string[] = [];
  const createResearchExperience = addApplicationItem(
    'researchExperiences',
    refetchApplication,
  );
  const updateResearchExperience = useUpdateResearchExperience();

  const { researchExperienceFormData, loading, error } =
    useGetResearchExperienceFormData(researchExperience);
  const { researchProposal, ...others } = researchExperienceFormData;
  if (Object.keys(others).length > 0) {
    initialValues = others;
    initialResearchProposals.push(researchProposal);
  }

  let alertDetailDef: AlertDetails = {
    alertContent: '',
    alertType: 'error',
  };
  const [openAlert, setOpenAlert] = useState(false);
  const [alertDetails, setAlertDetails] =
    useState<AlertDetails>(alertDetailDef);

  const handleSubmit = async (
    values: ResearchExperienceFormValues,
  ): Promise<void> => {
    await handleLoading(async () => {
      try {
        if (isCreateMode) {
          const res = await createResearchExperience({
            variables: {
              id,
              input: {
                researchExperience: {
                  ...values,
                },
              },
            },
          });
          const resResearchExperienceId =
            res.data?.addApplicationItem.researchExperiences[0]._id;
          setResearchExperience(resResearchExperienceId);
          setIsCreateMode(!(resResearchExperienceId as string));
        } else {
          await updateResearchExperience({
            variables: {
              id: researchExperienceId,
              ...values,
            },
          });
        }
        alertDetailDef = {
          alertContent: 'Saved Research Experience Successfully.',
          alertType: 'success',
        };
      } catch (error: any) {
        alertDetailDef = {
          alertContent:
            'Saved Research Experience Failed.' + (error as Error).message,
          alertType: 'error',
        };
      } finally {
        setAlertDetails(alertDetailDef);
      }
    });
    setOpenAlert(true);
  };

  if (error) {
    return (
      <Alert
        openAlert={true}
        setOpenAlert={() => {}}
        alertDetails={{
          alertContent: `Error Occurs.` + (error as Error)?.message,
          alertType: 'error',
        }}
      />
    );
  }

  // const [filesLoading, setFilesLoading] = useState<boolean>(false);
  // const files =
  //   supportDocument.map(documentId => ({
  //     id: documentId,
  //     name: '',
  //     link: '',
  //   })) ?? [];

  // function handleFilesChange(order: number, id?: string): boolean {
  //   let newFilesArray = supportDocument;
  //   switch (order) {
  //     case FILE_MANAGE_ORDER.UPLOAD:
  //       newFilesArray = [...newFilesArray, id as string];
  //       break;
  //     case FILE_MANAGE_ORDER.REMOVE:
  //       if (typeof id === 'string' && newFilesArray.includes(id)) {
  //         const index = newFilesArray.indexOf(id);
  //         newFilesArray.splice(index, 1);
  //         setSupportDocument(newFilesArray);
  //       }
  //       break;
  //     default:
  //   }
  //   setSupportDocument(newFilesArray);
  //   return true;
  // }

  return (
    <>
      <Alert
        openAlert={openAlert}
        setOpenAlert={setOpenAlert}
        alertDetails={alertDetails}
      />
      {loading ? (
        <Loading />
      ) : (
        <Accordion
          defaultExpanded
          title={PAGE_TEXT.OTHER_INFORMATION.RESEARCH_EXPERIENCE.TITLE}
          details={
            <div>
              {/* {filesLoading && <Loading />} */}
              <Container>
                <ResearchExperienceForm
                  initialValues={initialValues}
                  isHKPFSApplicant={isHKPFSApplicant}
                  enableEdit={enableEdit}
                  onSubmit={handleSubmit}
                />
                {/* 
            // not sure if they want it to be changed as well
            <FilesPanel
              enableAddFile={enableEdit}
              disableDeleteOnly={!enableDelete}
              title={pageText.FILES_PANEL.PANEL_TITLE}
              caption={pageText.FILES_PANEL.PANEL_CAPTION}
              files={files}
              handleFilesChange={handleFilesChange}
              setLoading={setFilesLoading}
            /> */}
              </Container>
            </div>
          }
        />
      )}
    </>
  );
};

const Container = styled.div`
  margin-top: 35px;
  display: flex;
  flex-direction: row;
  width: 100%;

  .MuiBox-root {
    padding: 0 0.6rem;
  }
`;
